import lmsAPI from "./lmsAPI";

class TagsService {
  async index() {
    const res = await lmsAPI.get(`/tags/`);
    return res.data;
  }

  async get(id) {
    const res = await lmsAPI.get(`/tags/${id}`);
    return res.data;
  }

  async update(id, tagParams) {
    const res = await lmsAPI.put(`/tags/${id}`, { tag: tagParams });
    return res.data;
  }

  async create(tagParams) {
    const res = await lmsAPI.post(`/tags/`, { tag: tagParams });
    return res.data;
  }

  async delete(id) {
    const res = await lmsAPI.delete(`/tags/${id}`);
    return res.data;
  }

  async bulkDelete(tagIDs) {
    const res = await lmsAPI.delete("/tags/batch_destroy", {
      data: { tag_ids: tagIDs },
    });
    return res.data;
  }
}

export default new TagsService();
